.scrollContainer {
    overflow-x: auto;
    overflow-y: auto;
    scrollbar-color: #eaecf0 transparent;
    scrollbar-width: thin;
    padding-right: 8px;
}
